module.exports = __webpack_public_path__ + "files/6ba3b2165614116603bfb3e2df5698f7.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-72x72.png
// module id = 567
// module chunks = 60